import React from 'react';
import useLangRelPathBase from '../../i18n/useLangRelPathBase';
import { t } from '../../i18n/i18n';
import { useI18nInitNamespace } from '../../i18n/useI18nInitNamespace';
import aboutZerobounceTranslations from '../../i18n/translations/pages/about-zerobounce.json';
import { StyledA } from '../../styles/generic/globalStyledComponents/StyledA';

export const TranslateMenuItem = (text) => {
  useI18nInitNamespace('aboutZerobounce', aboutZerobounceTranslations, true);
  return t(text);
};

const StyledLink = (props) => {
  const langRelPathBase = useLangRelPathBase();
  let href = props.href;

  // Had to include the && !href.includes('/es/') as when using LangA in section-guide.js it would end up adding /es/es. This rule is not bulletproof as it doesnt cover a potential case when being on the homepage and having /es. However, so far we dont have such case on the platform
  if (href?.startsWith('/') && !href.includes('/es/')) {
    href = langRelPathBase + href;
  }
  const modifiedProps = { ...props, children: undefined, href };

  const text = props.translate ? TranslateMenuItem(props.children) : props.children;

  return <StyledA {...modifiedProps}>{text}</StyledA>;
};

export default StyledLink;
